import pick from '../pictures/Image 557.png'
import './overView1.css'
import React from 'react';


export default function OverView1() {
    return (
        <div className="overView1">
            <div className="text">
                <div className="over">Overview</div>
                <div className="build">Built By The Best</div>
                <div className="words"><p>Elevate is the brainchild of two industry stalwarts -
                 pan-India developer, Conscient and global giant, Hines.
                 Teaming up with this formidable duo, Tata  Projects now joins them as a construction partner.
                 This oasis of serenity has been perfected with masterful strokes from Ricardo,
                     an internationally renowned Spanish architecture firm.</p>

                    <br />
                    <p>These landmark residences bring to you
                    an elevated living experience with a balance of world-class architecture, engineering
                     excellence and construction expertise, delivered only by the best in the industry.</p></div>
            </div>
            <div className="pic">
                <img src={pick} alt="" />
                <div className="symbol1">
                    <div className="accent1">Accent</div>
                    <div className="build2">Buidtech Pvt Ltd.</div>
                </div>
            </div>
        </div>
    );

}